import { Pipe, PipeTransform } from '@angular/core';
import { SortOptions } from '../models/sort-options.model';
import { SortingDirection } from '../enums/sorting-direction.enum';

@Pipe({
    name: 'sort',
})
export class SortPipe implements PipeTransform {
    transform(items: any[], sortOptions: SortOptions): any[] {
        const column = sortOptions.sortingField;
        const isAsc = sortOptions.direction !== SortingDirection.desc;

        if (column === 'lastEditor') {
            return items.sort((a, b) => {
                let returnValue = 0;
                if (a[column]['name'].toLowerCase() < b[column]['name'].toLowerCase()) {
                    returnValue = isAsc ? -1 : 1;
                } else if (a[column]['name'].toLowerCase() > b[column]['name'].toLowerCase()) {
                    returnValue = isAsc ? 1 : -1;
                }
                return returnValue;
            });
        }

        return items.sort((a, b) => {
            let returnValue = 0;

            let aCompare = a[column];
            let bCompare = b[column];

            if (typeof aCompare === 'string' && typeof bCompare === 'string') {
                aCompare = aCompare.toLowerCase();
                bCompare = bCompare.toLowerCase();
            }

            if (aCompare < bCompare) {
                returnValue = isAsc ? -1 : 1;
            } else if (aCompare > bCompare) {
                returnValue = isAsc ? 1 : -1;
            }
            return returnValue;
        });
    }
}
